<!-- Dialog Title -->
@if (!clientAdded) {
  <h2 mat-dialog-title>{{ ((data?.clientId ?? false) ? 'clientForm.editClient' : 'clientForm.addNewClient') | transloco }}</h2>
}

<!-- Dialog Content -->
<mat-dialog-content>
  <div class="dialog-content">
    @if (!clientAdded) {
        <!-- Initial Form State -->
        <form [formGroup]="clientForm">
          <div>
            <mat-form-field class="small-form-field">
              <span>{{ 'clientForm.clientId' | transloco }}</span>
              <input matInput formControlName="clientID" required>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="small-form-field">
              <span>{{ 'clientForm.requireClientSecret' | transloco }}</span>
              <mat-select formControlName="requireClientSecret">
                <mat-option [value]="null"></mat-option>
                <mat-option [value]="true">{{ 'clientForm.true' | transloco }}</mat-option>
                <mat-option [value]="false">{{ 'clientForm.false' | transloco }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="small-form-field">
              <span>{{ 'clientForm.allowedGrantTypesCsv' | transloco }}</span>
              <input matInput formControlName="allowedGrantTypesCsv">
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="small-form-field">
              <span>{{ 'clientForm.requirePkce' | transloco }}</span>
              <mat-select formControlName="requirePkce">
                <mat-option [value]="null"></mat-option>
                <mat-option [value]="true">{{ 'clientForm.true' | transloco }}</mat-option>
                <mat-option [value]="false">{{ 'clientForm.false' | transloco }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="small-form-field">
              <span>{{ 'clientForm.allowAccessTokensViaBrowser' | transloco }}</span>
              <mat-select formControlName="allowAccessTokensViaBrowser">
                <mat-option [value]="null"></mat-option>
                <mat-option [value]="true">{{ 'clientForm.true' | transloco }}</mat-option>
                <mat-option [value]="false">{{ 'clientForm.false' | transloco }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="small-form-field">
              <span>{{ 'clientForm.allowPlainTextPkce' | transloco }}</span>
              <mat-select formControlName="allowPlainTextPkce">
                <mat-option [value]="null"></mat-option>
                <mat-option [value]="true">{{ 'clientForm.true' | transloco }}</mat-option>
                <mat-option [value]="false">{{ 'clientForm.false' | transloco }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="small-form-field flex-item">
              <span>{{ 'clientForm.redirectUrisCsv' | transloco }}</span>
              <input matInput formControlName="redirectUrisCsv">
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="small-form-field flex-item">
              <span>{{ 'clientForm.postLogoutRedirectUrisCsv' | transloco }}</span>
              <input matInput formControlName="postLogoutRedirectUrisCsv">
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="small-form-field flex-item">
              <span>{{ 'clientForm.allowedScopesCsv' | transloco }}</span>
              <input matInput formControlName="allowedScopesCsv">
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="small-form-field">
              <span>{{ 'clientForm.allowOfflineAccess' | transloco }}</span>
              <mat-select formControlName="allowOfflineAccess">
                <mat-option [value]="null"></mat-option>
                <mat-option [value]="true">{{ 'clientForm.true' | transloco }}</mat-option>
                <mat-option [value]="false">{{ 'clientForm.false' | transloco }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="small-form-field">
              <span>{{ 'clientForm.requireConsent' | transloco }}</span>
              <mat-select formControlName="requireConsent">
                <mat-option [value]="null"></mat-option>
                <mat-option [value]="true">{{ 'clientForm.true' | transloco }}</mat-option>
                <mat-option [value]="false">{{ 'clientForm.false' | transloco }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="small-form-field flex-item">
              <span>{{ 'clientForm.accessTokenLifetime' | transloco }}</span>
              <input matInput formControlName="accessTokenLifetime">
            </mat-form-field>
          </div>
          <!-- Add other fields as necessary -->
        </form>
    } @else {
      <!-- Success Message State -->
      <div class="success-message">
        <p><strong>{{ clientName }}</strong> {{ 'clientForm.hasBeenAddedSuccessfully' | transloco }}</p>
        <mat-divider></mat-divider>
        <p><strong>{{ 'clientForm.clientSecret' | transloco }}</strong></p>
        <div>
          <p>{{ clientSecret }}</p>
          <button mat-icon-button (click)="copyClientSecret()" [matTooltip]="'clientForm.copyToClipboard' | transloco">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
        <p class="warning-message">
          {{ 'clientForm.saveThisSecretAfterThisDialog' | transloco }}
        </p>
        <div class="actions">
          <button mat-raised-button color="accent" (click)="closeDialog()">{{ 'common.buttons.close' | transloco }}</button>
        </div>
      </div>
    }
  </div>
</mat-dialog-content>

<!-- Dialog Actions -->
@if (!clientAdded) {
  <mat-dialog-actions align="center">
    <button mat-button (click)="onCancel()">{{ 'common.buttons.cancel' | transloco }}</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="clientForm.invalid">{{ ((data?.clientId ?? false) ? 'common.buttons.save' : 'common.buttons.add') | transloco }}</button>
  </mat-dialog-actions>
}

<!-- Success Template -->
